import { getTravellerFormSchemaRequestKey } from './request/travellerSchema'

const getCheckoutTravellerSchema = (state: App.State) => state.checkout.schemaData[getTravellerFormSchemaRequestKey(state)]

export function isCheckoutTravellerSchemaReady(
  schemaData: App.Checkout.TravellerFormSchemaData | null | undefined,
  isFetchingSchema: boolean,
  isFormInitialised: boolean,
): boolean {
  return !!schemaData?.accommodationFlightSchema && !isFetchingSchema && isFormInitialised
}

export function isCheckoutTravellerReadinessSatisfied({
  checkoutNeedsTravellerForms,
  shouldShowTravellerForm,
  schemaData,
  isFetchingSchema,
  isFormInitialised,
  isGuestCheckoutMode,
}: {
  checkoutNeedsTravellerForms: boolean
  shouldShowTravellerForm: boolean
  schemaData: App.Checkout.TravellerFormSchemaData | null | undefined
  isFetchingSchema: boolean
  isFormInitialised: boolean
  isGuestCheckoutMode?: boolean
}): boolean {
  if (!checkoutNeedsTravellerForms) {
    return true
  }

  // Guest checkout never loads a traveller schema; GuestContactDetailsSection
  // collects the same fields directly into the primary traveller form.
  if (isGuestCheckoutMode) {
    return true
  }

  if (!shouldShowTravellerForm) {
    return false
  }

  return isCheckoutTravellerSchemaReady(schemaData, isFetchingSchema, isFormInitialised)
}

export default getCheckoutTravellerSchema
